import { isEmpty } from "@/utils/funcs";
/**
 * Gets the current authenticated user from state
 * @param state - Redux state
 * @returns Current user object or null
 */
export var getCurrentUser = function (state) { var _a, _b; return !isEmpty((_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.currentUser) ? (_b = state === null || state === void 0 ? void 0 : state.auth) === null || _b === void 0 ? void 0 : _b.currentUser : null; };
/**
 * Checks if user is authenticated
 * @param state - Redux state
 * @returns Authentication status
 */
export var isAuthenticated = function (state) { var _a; return Boolean((_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.isAuthenticated); };
/**
 * Gets user preferences from state
 * @param state - Redux state
 * @returns User preferences object or null
 */
export var getUserPreferences = function (state) { var _a, _b; return typeof ((_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.userPreferences) === "object" ? (_b = state === null || state === void 0 ? void 0 : state.auth) === null || _b === void 0 ? void 0 : _b.userPreferences : null; };
/**
 * Gets user's preferred date format
 * @param state - Redux state
 * @returns Date format string or null
 */
export var getCurrentUserDateFormat = function (state) {
    var _a;
    var preferences = getUserPreferences(state);
    return ((_a = preferences === null || preferences === void 0 ? void 0 : preferences.date) === null || _a === void 0 ? void 0 : _a.date_format) || null;
};
/**
 * Gets user's preferred time format
 * @param state - Redux state
 * @returns Time format string or null
 */
export var getCurrentUserTimeFormat = function (state) {
    var _a;
    var preferences = getUserPreferences(state);
    return ((_a = preferences === null || preferences === void 0 ? void 0 : preferences.date) === null || _a === void 0 ? void 0 : _a.time_format) || null;
};
/**
 * Gets the refresh token from state
 * @param state - Redux state
 * @returns Refresh token
 */
export var getRefreshToken = function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.auth) === null || _a === void 0 ? void 0 : _a.refreshToken; };
